<template>
  <div class="box">
    <div class="addProcert">
    <van-form @submit="onSubmit">
        <!-- <van-cell-group> -->
          <!-- <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.empno" placeholder="请输入工号" label="工号"/> -->
        <!-- </van-cell-group> -->
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" readonly clickable :value="baseinfo.procerttype" label="专业认证类型" placeholder="请输入专业认证类型" @click="showProcerttype = true,getDict('procerttype')"/>
          <van-popup v-model="showProcerttype" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              @confirm="onConProcerttype"
              @cancel="showProcerttype = false"
            />
          </van-popup>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certname" placeholder="请输入职业资格名称" label="职业资格名称"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certename" placeholder="请输入证书英文名" label="证书英文名"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" type="date" v-model="baseinfo.certgetdate" placeholder="请输入获得日期" label="获得日期"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certno" placeholder="请输入编号" label="编号"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" required :rules="[{ required:true, message: '请输入' }]" v-model="baseinfo.certgrade" placeholder="请输入等级" label="等级"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.files" placeholder="请输入附件" label="附件(图片)"/>
        </van-cell-group>
        <van-cell-group>
          <van-field input-align="right" v-model="baseinfo.remark" placeholder="请输入备注" label="备注"/>
        </van-cell-group>
        <div class="btnBox">
            <van-button round block type="info" native-type="submit" class="btn">确认</van-button>
        </div>
    </van-form>
    <div class="footer">
      <van-button round block class="btnClo" @click="toInfo">取消</van-button>
    </div>
  </div>
  </div>
</template>

<script>
import api from '@/apis'
import moment from 'moment'
export default {
  name: "addProcert",
  data(){
    return {
      baseinfo:{
        "empno": "", //员工工号
        "procerttype": "", //专业认证类型
        "certname": "", //专业技术资质名称
        "certename": "", //证书英文名
        "certgetdate": "", //获得日期
        "certno": "", //编号
        "remark": "", //备注
        "certgrade": "", //等级
        "files": "", //附件（图片）
      },
      showProcerttype:false,
      columns:[],
      itemId:[],
      id:{
        idProcerttype:'',
      }
    }
  },
  methods: {
    //获取专业认证类型列表
    getDict(type){
      api.setGetDicts({type}).then((data)=>{
          this.itemId = data.data
          let items = data.data
          this.columns = []
          items.forEach(item=>{
            this.columns.push(item.title)
          })
      })
    },
    //改变专业认证类型
    onConProcerttype(value){
      const str = this.itemId.find(item=>{
        return item.title === value
      })
      this.id.idProcerttype = str.id
      this.baseinfo.procerttype = value
      this.showProcerttype = false
    },
    // 提交表单
    onSubmit(){
      let obj = {
        ...this.baseinfo,
        procerttype:this.id.idProcerttype,
        certgetdate:moment(this.baseinfo.certgetdate).format('YYYY-MM-DD'),
        table:'euBgprocertList',
        saveType:'1',
        empid:this.$store.state.userInfo.empID,
        empno:this.$store.state.userInfo.empNo
      }
      api.setSaveEmpInfo(obj).then(()=>{
        this.$toast('添加成功');
        this.$router.push({
        path:'/mobile/info',
        query:{
          type:'add'
        }
        })
      })
    },
    // 跳转
    toInfo(){
      this.$router.push({
        path:'/mobile/info',
        query:{
          type:'no'
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .addProcert {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .addProcert {
    width: 276px * $zoom;
  }
}
.box{
  display: flex;
  justify-content: center;
}
::v-deep .van-picker__toolbar{
    height: 40px * $zoom;
    .van-picker__cancel{
      font-size: 0.42667rem;
    }
    .van-picker__confirm{
      font-size: 16px * $zoom;
    }
  }
  ::v-deep .van-ellipsis{
    font-size: 8px * $zoom;
  }
.addProcert {
  font-size: 16px * $zoom;
  min-height: 100vh;
  background: #f4f5f8;
  position: relative;
}
.fromBox{
    height: 90vh;
}
.btnBox{
    width: 50%;
    position: absolute;
    bottom: 20px * $zoom;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 10px * $zoom 20px * $zoom;
    margin-left: 50%;
}
.btn {
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
}
.footer{
  width: 50%;
  position: absolute;
  bottom: 20px * $zoom;
  display: flex;
  justify-content: flex-end;
  padding: 10px * $zoom 20px * $zoom;
}
.btnClo{
  width: 80px * $zoom;
  font-size: 12pt;
  padding: 5px * $zoom;
  border: none;
}
</style>
